import { Badge } from 'react-bootstrap';
import { FaShoppingCart, FaWhatsapp } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../../assets/styles/floatingCart.css';
import { selectCartItems } from '../../slices/cartSlice';

const FloatingCartIcon = () => {
    const location = useLocation();
    const { pathname } = location;

    const hiddenPaths = ['/cart', '/shipping', '/payment', '/placeorder', '/order'];

    const isHidden = hiddenPaths.some((path) => pathname.startsWith(path));
    const cartItems = useSelector(selectCartItems);
    const whatsappPhone = (process.env.REACT_APP_WHATSAPP_PHONE || '').replace(/[^\d]/g, '');
    const whatsappLink = whatsappPhone ? `https://wa.me/${whatsappPhone}` : '';

    const totalItems = cartItems.reduce((sum, item) => sum + item.qty, 0);

    if (isHidden) return null;

    return (
        <div className="floating-action-buttons">
            {whatsappLink && (
                <a
                    href={whatsappLink}
                    className="floating-action-btn floating-whatsapp-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Chatear por WhatsApp"
                >
                    <FaWhatsapp size={30} color="white" />
                </a>
            )}

            <Link to="/cart" className="floating-action-btn floating-cart-icon" aria-label="Ver carrito">
                <FaShoppingCart size={30} color="white" />
                {totalItems > 0 && (
                    <Badge pill bg="danger" className="cart-badge">
                        {totalItems}
                    </Badge>
                )}
            </Link>
        </div>
    );
};

export default FloatingCartIcon;
